import {default as router, adminRouters,normalRouters,superAdmin} from "./router";
import {getToken,getCurrentTitle,removeToken} from '@/utils/auth' // get token from cookie
import {getAcctInfo} from './api/login'
import store from './store'
import alertify from 'alertifyjs'

const whiteList = ['/admin-login'] // no redirect whitelist

console.log(router);

router.beforeEach((to, from, next) => {
  console.log("router beforeEach", to, from)
  store.dispatch('setProgress', true)
  let urlArr=GetRequest();
  console.log(urlArr,'urlArr');

  if(urlArr.tk){
    // alert('tk');
    removeToken();
    store.dispatch('logIn',urlArr.tk).then(() => {

    });
  }

  if (getToken()) {

    if (whiteList.indexOf(to.path) !== -1) {
      if(to.path.indexOf('\/admin') == 0){
        removeToken();
      }
      // 在免登录白名单，直接进入
      next();
    }else{
      // 是否获取到账户信息（刷新后就需要重新获取）
      if (!store.getters.acctLoaded) {
        // 获取账户信息
        getAcctInfo().then(res => {
          store.dispatch('acctInfoSet', {
            isAdmin: res.isAdmin,
            acctName: !res.acctVO?'':res.acctVO.acctName,
            compName: !res.acctVO?'':res.acctVO.compName
          });
          let routers=[];
          if (res.isAdmin=='admin') {
            // 管理员权限
            routers = adminRouters;
          } else if(res.isAdmin=='normal'){
            // 普通用户权限
            routers = normalRouters
          }else if(res.isAdmin=='superAdmin'){
            // 超级管理员权限
            routers = superAdmin
          }
          store.dispatch('setRouters', routers[0].children);
          router.addRoutes(routers);
          next({...to, replace: true});
          if (getCurrentTitle()) {
            store.dispatch('setCurretTitle', getCurrentTitle())
          }
          store.dispatch('setProgress', false)
        }).catch(err => {
          store.dispatch('setProgress', false)
          console.log(err)
        })
      } else {
        store.dispatch('setProgress', false)
        next()
      }
    }
  } else {
    // 没有token  看导航栏是否有tk
    // if(urlArr.tk){
    //   store.dispatch('logIn',urlArr.tk);
    //   next({...to, replace: true});
    //   store.dispatch('setProgress', false);
    // }else{
      if (whiteList.indexOf(to.path) !== -1) {
        // 在免登录白名单，直接进入
        next()
      } else {
        // 否则回到首页
        if (to.path.indexOf('\/admin') == 0) {
          next(`/admin-login?redirect=${to.path}`) // 否则全部重定向到登录页
        } else {
          alertify.alert(
            '权限', '无系统访问权限。',function(){
              window.location.href='http://hosp.zzitec.com/#/'
            }).set('closable', false).set('label', '确定');
        }
      }
      store.dispatch('setProgress', false)
    // };
  }
})

function GetRequest() {
  var url = window.location.href; //获取url中"?"符后的字串
  var theRequest = new Object();
  if (url.indexOf("?") != -1) {
    var urls=url.split("?");
    var str = urls[1];
    var strs = str.split("&");
    for(var i = 0; i < strs.length; i ++) {
      theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
    }
  }
  return theRequest;
}


// 如果要加默认layout,在这补充
function transMenuToRouter(menus) {
  let routers = []
  let routersAll=[]
  menus.forEach(menu => {
    routers.push({
      path: menu.path,
      name: menu.component,
      component: () => import(`@/views/${menu.component}`),
      meta: { title: menu.menuName }
    })
  })
  routersAll=[{
    path: '/layout',
    name: 'Layout',
    component: () => import('@/views/Layout'),
    children:routers
  }]
  return routersAll;
}